const USER_DATA = "USER_DATA";
const PROSPECT_DATA = "PROSPECT_DATA";
const EDIT_PROSPECT = "EDIT_PROSPECT";

export { USER_DATA, PROSPECT_DATA, EDIT_PROSPECT };
